import { useAuth } from '../auth';

export function useUserName(): { firstName: string; initials: string } {
  const { user } = useAuth();
  const meta = user?.user_metadata;
  const fullName: string = meta?.full_name ?? meta?.name ?? user?.email?.split('@')[0] ?? '';
  const firstName = fullName.split(' ')[0] || 'there';
  const parts = fullName.split(' ').filter(Boolean);
  const initials = parts.length >= 2
    ? (parts[0]![0]! + parts[parts.length - 1]![0]!).toUpperCase()
    : (parts[0]?.[0] ?? '?').toUpperCase();
  return { firstName, initials };
}
